import theme from '../../theme';

const getCompletionStatusChipStyles = (isComplete) => {
  const colors = isComplete
    ? {
      backgroundColor: theme.palette.success.A100,
      color: theme.palette.success.A700,
    }
    : {
      backgroundColor: theme.palette.error.A100,
      color: theme.palette.error.A700,
    };

  return {
    ...colors,
    borderRadius: '16px',
    height: 24,
    fontSize: '0.75rem',
    fontWeight: 600,
  };
};

export const getCompletionStatusChipLabel = (isComplete) => (
  isComplete ? 'Completado' : 'Faltan datos'
);

export default getCompletionStatusChipStyles;
